"use client";
import "../chunk-GOCCUU3Z.js";
import parsePhoneNumberFromString from "libphonenumber-js";
const formatPhoneNumber = (phone, countryCode) => {
  phone = phone.toString();
  countryCode = countryCode == null ? void 0 : countryCode.toString();
  let sanitizedNumber, parsedNumber;
  if (!!countryCode) {
    sanitizedNumber = phone.replace(/\D/g, "");
    if (/^\+\d+$/.test(countryCode)) {
      countryCode = countryCode.slice(1);
    }
    parsedNumber = parsePhoneNumberFromString(sanitizedNumber, { defaultCallingCode: countryCode });
  } else {
    sanitizedNumber = `${phone.startsWith("+") ? "" : "+"}${phone.replace(/[^\d+]/g, "")}`;
    parsedNumber = parsePhoneNumberFromString(sanitizedNumber);
  }
  if (parsedNumber == null ? void 0 : parsedNumber.isValid()) {
    return parsedNumber.formatInternational();
  }
  return null;
};
export {
  formatPhoneNumber
};
